export class Agrupador {
  id:number;
  nome: string;
}
